import React, { useState } from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import Input from 'components/Input';
import InputDate from 'components/InputDate/view/mobile';
import Select from 'components/Selectors/Select/mobile';
import Button from 'components/Button';
import SVG from 'components/SVG';
import { selectSportHistoryLocale } from 'features/sportHistory/redux/selectors';
import arrowDownSVG from 'features/sportHistory/img/arrow-down.svg';
import arrowUpSVG from 'features/sportHistory/img/arrow-up.svg';
import filterSVG from 'features/sportHistory/img/filter.svg';

import './FilterBlock.scss';

const b = block('filter-block-desktop');

const FilterBlock = ({ filter }) => {
  const locale = useSelector(selectSportHistoryLocale);

  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className={b()}>
      <div className={b('header')}>
        <SVG
          containerClassName={b('filter-icon')}
          svgProps={{
            svg: filterSVG,
          }}
        />
        <h2 className={b('title')}>{locale.title}</h2>
        <button type="button" onClick={() => setIsOpen(ps => !ps)} className={b('arrow')}>
          <SVG
            containerClassName={b('arrow-icon', {
              isOpen: !isOpen,
            })}
            svgProps={{
              svg: arrowDownSVG,
            }}
          />
          <SVG
            containerClassName={b('arrow-icon', {
              isOpen,
            })}
            svgProps={{
              svg: arrowUpSVG,
            }}
          />
        </button>
      </div>
      <form className={b('form', { isOpen })} onSubmit={filter.handleSubmit}>
        <div className={b('inputs')}>
          <div className={b('input')}>
            <div className={b('label')}>
              {locale.from}
            </div>
            <InputDate selected={filter.values.from} onChange={filter.handleFromChange}/>
          </div>
          <div className={b('input')}>
            <div className={b('label')}>
              {locale.to}
            </div>
            <InputDate selected={filter.values.to} onChange={filter.handleToChange} />
          </div>
          <div className={b('input')}>
            <div className={b('label')}>
              {locale.type.title}
            </div>
            <Select items={filter.values.type} onChange={filter.handleTypeChange} />
          </div>
          <div className={b('input')}>
            <div className={b('label')}>
              {locale.status.title}
            </div>
            <Select items={filter.values.status} onChange={filter.handleStatusChange} />
          </div>
          <div className={b('input')}>
            <div className={b('label')}>
              {locale.userId}
            </div>
            <Input value={filter.values.userId} onChange={e => filter.handleUserIdChange(e.target.value)} />
          </div>
          <div className={b('input')}>
            <div className={b('label')}>
              {locale.couponId}
            </div>
            <Input value={filter.values.couponId} onChange={e => filter.handleCouponIdChange(e.target.value)} />
          </div>
        </div>
        <div className={b('bottom')}>
          <div className={b('input')}>
            <div className={b('label')}>
              {locale.username}
            </div>
            <Input size="low" value={filter.values.username} onChange={e => filter.handleUsernameChange(e.target.value)} />
          </div>
          <div className={b('button-group')}>
            <Button text={locale.submit} type="submit" />
          </div>
        </div>
      </form>
    </div>
  );
};

export default FilterBlock;
